var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.states,"outlined":_vm.outlined,"dense":"","label":_vm.label,"item-value":"value","item-text":"name","rules":_vm.rules,"background-color":_vm.backgroundColor},on:{"change":_vm.changed},model:{value:(_vm.selectedState),callback:function ($$v) {_vm.selectedState=$$v},expression:"selectedState"}})
}
var staticRenderFns = []

export { render, staticRenderFns }